/**
 * Return the CSRF token defined on the document
 * @return {String}
 */
export default () => {
  const metaElement = document.head.querySelector('meta[name="csrf-token"]');

  if (metaElement) {
    return metaElement.content;
  }

  return '';
};
